import { createContext } from 'react';
import {
	IGames,
	IDataGetRestaurantsByIDsCustomersForGames,
	IDataGetGamesByIDsRestaurantsForGames,
	IGamesByIDsRestaurantsForGames,
	IDataGetCustomersForAssignGame,
} from 'types';

export type TSelectedItem = Nullable<string>;
export type TGamesSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TActiveItemToDisplay = 'customers' | 'restaurants' | 'games';
export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSendChanges' | 'success' | 'error';
export interface IIDsSelectedItems {
	[key: string]: boolean; // key - is the ID and boolean means open or closed tab status.
}
export interface IGameWithAdditionalField extends IGamesByIDsRestaurantsForGames {
	isAddedDishFromList: boolean;
}
export interface IGamesWithAdditionalProperty extends IDataGetGamesByIDsRestaurantsForGames {
	isChanged: boolean;
	games: IGameWithAdditionalField[];
}
export type TCountOfItems = '12' | '24' | '48';

export interface IGameAssignmentState {
	gamesForAssign: IGames;
	searchString: string;
	searchStringForAllCustomers: string;
	searchStringForRestaurants: string;
	searchStringForGames: string;
	selectedCategory: TSelectedItem;
	selectedDeveloper: TSelectedItem;
	isUnassignedGames: boolean;
	sortBy: TGamesSortBy;
	IDsSelectedGame: string[];
	activeItemToDisplay: TActiveItemToDisplay;
	isShowBreadcrumbs: boolean;
	allCustomers: IDataGetCustomersForAssignGame[];
	IDsSelectedCustomers: IIDsSelectedItems;
	restaurants: IDataGetRestaurantsByIDsCustomersForGames[];
	IDsSelectedRestaurants: IIDsSelectedItems;
	games: IGamesWithAdditionalProperty[];
	typeOfModalWindow: TTypeOfModalWindow;
	currentPage: number;
	countOfItems: TCountOfItems;
}

export const gameAssignmentInitialState: IGameAssignmentState = {
	gamesForAssign: { gamesCount: 0, games: [] },
	searchString: '',
	searchStringForAllCustomers: '',
	searchStringForRestaurants: '',
	searchStringForGames: '',
	selectedCategory: null,
	selectedDeveloper: null,
	isUnassignedGames: false,
	sortBy: '',
	IDsSelectedGame: [],
	activeItemToDisplay: 'customers',
	isShowBreadcrumbs: false,
	allCustomers: [],
	IDsSelectedCustomers: {},
	restaurants: [],
	IDsSelectedRestaurants: {},
	games: [],
	typeOfModalWindow: null,
	currentPage: 1,
	countOfItems: '12',
};

export interface IGameAssignmentContext extends IGameAssignmentState {
	changeSearchString(value: string): void;
	changeSearchStringForAllCustomers(value: string): void;
	changeSearchStringForRestaurants(value: string): void;
	changeSearchStringForGames(value: string): void;
	setCategory(value: TSelectedItem): void;
	setDeveloper(value: TSelectedItem): void;
	toggleUnassignedGames(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TGamesSortBy): void;
	setIDsSelectedGame(value: string[]): void;
	changeActiveItemToDisplay(value: TActiveItemToDisplay): void;
	setShowBreadcrumbs(value?: boolean): void;
	setIDsSelectedCustomers(value: IIDsSelectedItems, isUpdateRestaurantsList: boolean): Promise<void>;
	setIDsSelectedRestaurants(value: IIDsSelectedItems, isUpdateGamesList: boolean): Promise<void>;
	addSelectedGamesToRestaurant(): void;
	deleteGameFromRestaurant(restaurantID: string, gameID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeCurrentPage(page: number): void;
	resetChanges(): void;
	sendChanges(): Promise<void>;
	updateModuleDataAfterSaving(): void;
}

export const GameAssignmentContext = createContext<IGameAssignmentContext>({
	changeSearchString: () => undefined,
	changeSearchStringForAllCustomers: () => undefined,
	changeSearchStringForRestaurants: () => undefined,
	changeSearchStringForGames: () => undefined,
	setCategory: () => undefined,
	setDeveloper: () => undefined,
	toggleUnassignedGames: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setIDsSelectedGame: () => undefined,
	changeActiveItemToDisplay: () => undefined,
	setShowBreadcrumbs: () => undefined,
	setIDsSelectedCustomers: async () => undefined,
	setIDsSelectedRestaurants: async () => undefined,
	addSelectedGamesToRestaurant: () => undefined,
	deleteGameFromRestaurant: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeCurrentPage: () => undefined,
	resetChanges: () => undefined,
	sendChanges: async () => undefined,
	updateModuleDataAfterSaving: () => undefined,
	...gameAssignmentInitialState,
});
